import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./routes/Home";
import Products from "./routes/Products";
import ProductPage from "./routes/ProductPage";
import ContactPage from "./routes/ContactPage";
import CheckoutPage from "./routes/CheckoutPage";
import Footer from "./components/Footer";
import FacebookChat from "./components/FacebookChat";
import ThankYouPage from "./routes/ThankYouPage";
import ReactGA from "react-ga";
import BlackFriday from "./components/homeComponents/BlackFriday";
import CartProvider from "./CartContext";
import CartCheckout from "./routes/CartCheckout";

function App() {
  ReactGA.initialize("G-WL1SLYXH7J ");
  return (
    <CartProvider>
      <div className="App">
        {/* <BlackFriday /> */}
        {/* {const unityContext = new UnityContext( loaderUrl: "builounity/ContainerApp.loader.js"
dataUrl: "buildUnity/ContainerApp.data",
frameworkUrl: "buildUnity/ContainerApp.framework.js", codeUrl: "buildUnity/ContainerApp.wasm",
webglContextAttributes: { preserveDrawingBuffer: true,
}. */}
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/produktet" element={<Products />} />
          <Route path="/produktet/:name" element={<ProductPage />} />
          <Route path="/direct-checkout" element={<ContactPage />} />
          <Route path="/checkout" element={<CartCheckout />} />
          <Route path="/produktet/checkout/:name" element={<CheckoutPage />} />
          <Route path="/thank-you-page" element={<ThankYouPage />} />
        </Routes>
        <Footer />
      </div>
    </CartProvider>
  );
}

export default App;
